export var bankDetailsMapper = function (data, accCode) {
    var result = [];
    if (data && data.length > 0) {
        data.map(function (item) {
            if (item.acCode === accCode) {
                var resultObj = {
                    bankName: item.bankName,
                    accountNo: item.accountNo,
                    accountType: item.accountType,
                    branch: item.branch,
                    address: item.address,
                    neftCode: item.nefT_Code,
                    default: item.default,
                    neftEnabled: item.nefT_Enabled,
                    acCode: item.acCode,
                };
                result.push(resultObj);
            }
        });
    }
    return result;
};
